<template>
  <div class="welcome">
      <div class="phone">
          <div class="banner">  
              <div class="southEast">
                  <p style="margin-bottom:15px;font-weight: bold;font-size: 20px;">{{$t('other.a2949')}}</p>
                  <p class="pibkg">{{$t('other.a2950')}}</p>
              </div>

              <div class="btn_wrapper">
                        <div class="btnItem" @click="openDkl()">{{$t('other.a3')}},{{$t('other.a2952')}}</div>
                        <!-- <div class="btnItem">价格体系</div> -->
                    </div>
          </div>

          <div>
              <div class="title">{{$t('other.a2951')}}</div>
              <div class="title">
                <div class="klkngd"></div>
              </div>
          </div>

          <div class="bkngd">
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/notyet.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a2953')}}</div>
                       <div class="olng">{{$t('other.a2954')}}</div>
                   </div>
                  </div>
              </div>

              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/claim.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a2955')}}</div>
                       <div class="olng">{{$t('other.a2956')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/message.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a2957')}}</div>
                       <div class="olng">{{$t('other.a2958')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/chat.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a2959')}}</div>
                       <div class="olng">{{$t('other.a2960')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/storenum.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a412')}}</div>
                       <div class="olng">{{$t('other.a413')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/return.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a416')}}</div>
                       <div class="olng">{{$t('other.a417')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/distribution.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a414')}}</div>
                       <div class="olng">{{$t('other.a2961')}}</div>
                   </div>
                  </div>
              </div>
              <div class="boxItmm">
                  <div class="qbwrapper">
                   <div class="picBox"><img src="@/assets/img/illdraw/chat.png" /></div>
                   <div class="descBotk">
                       <div class="desc">{{$t('other.a418')}}</div>
                       <div class="olng">{{$t('other.a419')}}</div>
                   </div>
                  </div>
              </div>
          </div>

          <div ref="kefu">
              <div class="title">{{$t('other.a3')}}</div>
              <div class="title">
                <div class="klkngd"></div>
              </div>
          </div>

           <div class="gonktn">
              <div>
                  <div class="okginkg">
                      <img src="@/assets/img/kefu.png"  />
                  </div>
                  <div class="onkgsc">{{$t('other.a2962')}}</div>
                  <div class="onkgsc">{{$t('other.a2963')}}</div>
                  
              </div>

              <div>
                  <div class="okginkg">
                      <img src="@/assets/img/kefu3.png"  />
                  </div>
                  <div class="onkgsc">{{$t('other.a2962')}}</div>
                  <div class="onkgsc">{{$t('other.a2963')}}</div>
                 
              </div>
          </div>

          <div>
              <div class="title">{{$t('other.a2964')}}</div>
              <div class="title">
                <div class="klkngd"></div>
              </div>
          </div>

          <div class="gonktn">
              <div>
                  <div class="hgkjbg">
                      <i class="iconfont tubiao icon-cangkukucun"></i>
                  </div>
                  <div class="onkgsc">{{$t('other.a2965')}}</div>
              </div>

              <div>
                  <div class="hgkjbg">
                      <i class="iconfont tubiao icon-kehufuwu"></i>
                  </div>
                  <div class="onkgsc">{{$t('other.a2966')}}</div>
              </div>
          </div>
          <div class="gonktn">
              <div>
                  <div class="hgkjbg">
                      <i class="iconfont tubiao icon-shouquan"></i>
                  </div>
                  <div class="onkgsc">{{$t('other.a2377')}}/</div>
                  <div class="onkgsc">{{$t('other.a2378')}}</div>
              </div>

              <div>
                  <div class="hgkjbg">
                      <i class="iconfont tubiao icon-cangku"></i>
                  </div>
                  <div class="onkgsc">{{$t('other.a2967')}}</div>
                  <div class="onkgsc">{{$t('other.a2968')}}</div>
              </div>
          </div>

          


      </div>
      <div class="pc">
          <el-dialog
		:visible.sync="formulaDia"
        :close-on-click-modal="false"
		width="20%"
		>
		<div style="display:flex;justify-content: center;">
            <div class="bkugk">
                <img v-show="showImg" src="@/assets/img/kefu.png"  />
                <span v-show="showImg">{{$t('other.a2969')}}，{{$t('other.a3')}}</span>
                <img v-show="!showImg" src="https://xianggangerp.oss-cn-hongkong.aliyuncs.com/customer-service/store-app.jpg">
                <span v-show="!showImg">{{$t('other.a2970')}} {{$t('other.a2971')}}</span>
            </div>
           
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="info" @click="formulaDia = false">{{$t('other.a5')}}</el-button>
		</span>
	</el-dialog>
      <div class="swiperImg">
          <img v-show="showPic" style="width:100%" src="@assets/img/bgwelcome01.jpg" />
          <img v-show="!showPic" style="width:100%" src="@assets/img/bgwelcome03.jpg" />

          <div class="circleWrapper">
            <span :class="{'circle':true, 'active':showPic}" @mouseenter="HovePic(0)" @mouseleave="beginSwiper()"></span>
            <span :class="{'circle':true, 'active':!showPic}" @mouseenter="HovePic(1)" @mouseleave="beginSwiper()"></span>

          </div>
          <div class="headerTitle">
              <div class="oknkg">
                  <div>
                  <span>{{$t('other.a2972')}}</span>
                    </div>
                    <div>
                        <span class="item">{{$t('other.a339')}}</span>
                        <span class="item" @click="goToIndex()">{{$t('other.a2973')}}</span>
                        <span class="item" @click="contack()">{{$t('other.a2974')}}</span>
                        <!-- <a style="color:#fff" href="https://www.weanaly.com/chrome-extension/download-crx">
                        <span class="item">shopee贝分板插件下载</span>
                        </a> -->
                        <span class="item" @click="downLoad()">{{$t('other.a2975')}}</span>
                    </div>
              </div>

              
              
          </div>
         
        <div class="footer">
            <div class="ignkt">
                <span class="tkng">
                    <img src="@/assets/img/tip1.png" />
                    <span style="margin-left:10px">
                        <p>{{$t('other.a2976')}} {{$t('other.a2977')}}</p>
                        <p>{{$t('other.a2978')}}</p>
                    </span>
                </span>
                <span class="tkng">
                    <img src="@/assets/img/tip2.png" />
                    <span style="margin-left:10px">
                        <p>{{$t('other.a2979')}} {{$t('other.a2980')}}</p>
                        <p>{{$t('other.a2981')}} {{$t('other.a2982')}} {{$t('other.a2983')}}</p>
                    </span>
                </span>
                <span class="tkng">
                    <img src="@/assets/img/tip3.png" />
                    <span style="margin-left:10px">
                        <p>{{$t('other.a2984')}} {{$t('other.a2985')}}</p>
                        <p>{{$t('other.a2967')}}，{{$t('other.a2968')}}</p>
                    </span>
                </span>
                <span class="tkng">
                    <img src="@/assets/img/tip4.png" />
                    <span style="margin-left:10px">
                        <p>{{$t('other.a2986')}} {{$t('other.a2987')}}</p>
                        <p>{{$t('other.a2988')}}</p>
                    </span>
                </span>
            </div>
        </div>

        <div  class="gundm">
                  <div class="registor">
                      <div class="ikngk">
                          <p>{{$t('other.a2973')}}</p>
                          <p>{{$t('other.a2989')}}</p>
                      </div>
                      <div class="oknri">
                          <el-button style="width:80%;magin:0 10px" type="primary" @click="goToIndex()">{{$t('other.a1765')}} / {{$t('registor.register')}}</el-button>
                      </div>
                      <div class="idsnc">
                          <span>{{$t('other.a2990')}}shopee/lazada</span>
                      </div>
                  </div>
              </div>
      </div>
      <div class="secondWrapper">
          <div class="center">
              <div class="uyjngkn">
                  <div class="ilkg">{{$t('other.a2991')}}</div>
              </div>
            <div class="ginkv">{{$t('other.a2992')}}(ERP&WMS)</div>

            <div class="yhkjg">
                <div class="ginlf">
                    <div class="igknv">
                        <p>{{$t('other.a2993')}}</p>
                        <p>{{$t('other.a2994')}} {{$t('other.a850')}}</p>
                    </div>
                    <div class="gint">
                        <p>{{$t('other.a2995')}}</p>
                        <p>{{$t('other.a2996')}}</p>
                    </div>
                </div>
                <div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/notyet.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a2953')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a2954')}}</div>
                    </div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/message.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a2957')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a2997')}}</div>
                        <div class="klng">{{$t('other.a2998')}}</div>
                    </div>
                </div>
                <div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/claim.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a2955')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a2999')}}</div>
                        <div class="klng">{{$t('other.a3000')}}</div>
                    </div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/chat.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a2959')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a2960')}}</div>
                    </div>
                </div>
            </div>

           

            <div class="yhkjg">
                
                <div class="ginlf">
                    
                    <div class="igknv">
                        <p>{{$t('other.a2976')}}</p>
                        <p>{{$t('other.a3001')}}</p>
                       
                    </div>
                    <div class="gint">
                        <p>{{$t('other.a3002')}}</p>
                        <p>{{$t('other.a3003')}}</p>
                    </div>
                </div>
                <div>
                     <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/storenum.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a412')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a413')}}</div>
                    </div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/return.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a414')}}</div>
                        
                        </div>
                        <div class="klng">{{$t('other.a415')}}</div>
                    </div>
                </div>
                <div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/distribution.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a416')}}</div>
                            <div class="deslk">{{$t('other.a3004')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a417')}}</div>
                    </div>
                    <div class="blockOne">
                        <div class="picBox"><img src="@/assets/img/illdraw/chat.png" /></div>
                        <div class="titledesc">
                            <div>{{$t('other.a418')}}</div>
                        </div>
                        <div class="klng">{{$t('other.a419')}}</div>
                    </div>
                </div>

                
            </div>
             <div class="ginkv">{{$t('other.a3005')}}</div>

             <div style="display:flex;justify-content: center;">
                  <div class="bkugk">
                      <img src="@/assets/img/kefu.png"  />
                      <span>{{$t('other.a2969')}}，{{$t('other.a3')}}</span>
                  </div>
                  <div class="bkugk"><img src="@/assets/img/kefu3.png"  />
                  <span>{{$t('other.a2969')}}，{{$t('other.a3')}}</span></div>
              </div>
          </div>
          
      </div>
      <div class="threeWrapper">
          <div class="footerHeader">
              <div class="tilng">
                    <div class="okngfdf"><i class="iconfont tubiao icon-cangkukucun"></i>{{$t('other.a2965')}}</div>
                    <div class="okngfdf"><i class="iconfont tubiao icon-kehufuwu"></i>{{$t('other.a2966')}}</div>
                    <div class="okngfdf"><i class="iconfont tubiao icon-shouquan"></i>{{$t('other.a2377')}}/{{$t('other.a2378')}}</div>
              </div>

              <div class="tilng bordl">
                  <div class="ilkg">{{$t('other.a2991')}}</div>
              </div>
              
          </div>
      </div>
      </div>
      
  </div>
</template>

<script>
export default {
data(){
return{
    showPic:false,
    TimeOut:null,
    formulaDia:false,
    showImg:false
}
},
created(){
    this.init()
    
},
methods:{
    init(){
        // let url=location.href
        // if(url.indexOf('shopsooo') == -1){
        //     this.$router.push('/index')
        //     return
        // }else{
        //     this.setPicSiper()
        // }
        this.setPicSiper()
    },
    openDkl(){
        this.$refs.kefu.scrollIntoView()
    },

    contack(){
        this.formulaDia=true
        this.showImg=true
    },

    downLoad(){
        this.formulaDia=true
        this.showImg=false
    },

    goToIndex(){
        // location.replace('https://shopsooo.com/sellerManagement')
        this.$router.push({
            path:'/index'
        })
    },
    setPicSiper(){
        this.TimeOut=setInterval(() => {
            this.showPic=!this.showPic
        }, 6000);
    },

    beginSwiper(){
        this.setPicSiper()
    },
    HovePic(num){
        if(num==0){
            this.showPic=true
        }else{
            this.showPic=false
        }
        clearInterval(this.TimeOut)
    },

}
}

</script>
<style lang="scss" scoped>

@media (max-width: 760px){
    .pc{
        display: none;
    }

    .tubiao{
        font-size: 59px!important;
    }

    .onkgsc{
        font-size: 14px;
        text-align: center;
    }

    .okginkg{
        width: 110px;
        height: 110px;
        overflow: hidden;

        img{
            width: 100%;
        }
    }


    .gonktn{
        display: flex;
        margin: 0 20px;
        justify-content: space-around;
   
        padding-bottom: 30px;

        .hgkjbg{
            display: flex;
            justify-content: center;
        }
    }

    .title{
        font-size: 18px;
        margin: 20px 0px;
        display: flex;
        justify-content: center;
        
    }

    .klkngd{
        width: 120px;
        height: 2px;
        background: rgb(56, 117, 231);
        text-align: center;
    }

    .bkngd{
        .boxItmm{
            box-sizing: border-box;
            margin: 0 20px 20px 20px;
            padding: 10px 20px;
            border-radius: 5px;
            box-shadow: 2px 2px 10px #eee;

            .descBotk{
                font-size: 18px;
                box-sizing: border-box;
                padding-top: 10px;
                padding-left: 10px;
                flex: 1;
                
               

                .desc{
                    font-size: 20px;
                    font-weight: bold;
                    color: #012257;
                    padding-bottom: 10px;
                }



                .olng{
                    font-size:15px;
                }

            }


            .qbwrapper{
                display: flex;
            }
            .picBox{
                width: 100px;
                height: 100px;
                overflow: hidden;

                img{
                    width: 100%;
                }
            }
            


        }
    }

    .banner{
        
        background-image: url('../assets/img/coopration.png') ;
        background-position: center;
        background-repeat:repeat;
        width: 100%;
        height: 550px;
        position: relative;

        .southEast{
            position: absolute;
            bottom: 130px;
            left: 0;
            right: 0;
            margin:  auto;
            text-align: center;
            font-size: 18px;
            color: #fff;
            font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            

            .pibkg{
                box-sizing: border-box;
                padding: 0 20px;
                line-height: 28px;
                
                
            }

            
        }


        .btn_wrapper{
            position: absolute;
            bottom: 20px;
            left: 0;
            right: 0;
            margin:  auto;
            display: flex;
            justify-content: center;

            .btnItem{
                font-size: 18px;
                color: #fff;
                border: 1px solid #fff;
                padding:10px 15px;
                border-radius: 5px;
                margin: 0 10px;
            }
        }

        
    }
}

@media (min-width: 1200px){

    .phone{
        display: none;
    }

    .welcome{
    font-family: helvetica,Hiragino Sans GB;
    position: relative;

    .uyjngkn{
        text-align: center;
        font-size: 18px;
        padding-top: 10px;
        color: red;
    }
    
    .swiperImg{
        position: relative;
        height: 100%;
       

        .gundm{
            width: 1200px;
            border-radius: 3px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 40px;
            margin: auto auto;
            display: flex;
            align-items: center;


            .registor{
                border-radius: 5px;
                width: 223px;
                height: 300px;
                background-color: #fff;
                position: absolute;
                right: 150px;
                margin-top: 20px;


                .ikngk{
                    padding: 50px 0 30px 15px;
                    font-size: 25px;
                    font-weight: 600;
                    line-height: 40px;
                    color: #012257;
                }

                .idsnc{
                    padding: 18px 0 0 26px;
                    font-size: 13px;
                    letter-spacing: .3px;
                    color: #97a2b5;

                }

                .oknri{
                    width: 220px;
                    text-align: center;
                }

            }
        }


        .circleWrapper{
            position: absolute;
            bottom: 80px;
            left: 0;
            right: 0;
            margin: 0 auto;
            text-align: center;
            z-index: 102;
            

            .circle{
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #fff;
                margin: 0 10px;
                cursor: pointer;
    
            }

            .active{
                background-color: aqua!important;
            }
        }

        .headerTitle{
            position: absolute;
            height: 60px;
            line-height: 60px;
            font-weight: bold;
            font-size:24px;
            top: 0;
            left: 0;
            right: 0;
            color: #fff;
            width: 1200px;
            margin: auto;
          
            z-index: 89;


            .oknkg{
                display: flex;
                justify-content: space-between;

                position: relative;


                 .wrapperBox{
                    position: absolute;
                    font-size:24px;
                    right: 0;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 1200px;
                    margin: auto;
                    z-index: 99;


                    .loginbox{
                        width: 150px;
                        height: 150px;
                        background-color: white;
                    }


            }


            .item{
                font-size: 16px;
                cursor: pointer;
                margin: 0 18px;
            }
        }


       
        }
        .footer{
            position: absolute;
            bottom: 4px;
            left: 0;
            right: 0;
            padding:10px 0;
            background-color: rgba(0,0,0,0.2);
            display: flex;
            justify-content: center;

            .ignkt{
                width: 1200px;
                display: flex;
                justify-content: space-between;

                .tkng{
                    display: flex;
                    font-size: 14px;
                    color: #dbe6f6;
                    padding-left: 8px;
                }

            }
            // background-color: #000;
        }
    }


    .okng{
        background-image: url('../assets/img/bgwel03.jpg') !important;
        background-position: 100% 100%;
        background-repeat: no-repeat;
    }


    .secondWrapper{
        width: 100%;
        height: 1580px;
        background-image: url('../assets/img/welcome02.jpg') ;
        background-position: 180% 100%;
        background-repeat: no-repeat;
        
        
        position: relative;


        .ginlf{
            width: 500px;
        }


        .yhkjg{
            display: flex;
            justify-content: flex-start;
          
        }

        .igknv{
            font-size: 35px;
            font-weight: bold;
            color: #012257;

        }

      

        .gint{
            margin-top: 30px;
        }

        p{
            margin: 10px 0;
        }
        

        .center{
            width: 1200px;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;

            .ginkv{
                padding: 50px 0 36px;
                font-size: 30px;
                font-weight: 600;
                letter-spacing: .91px;
                line-height: 42px;
                text-align: center;
                color: #012257;
            }

            .ingkl{
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
            }

            .blockOne{
                width: 380px;
                height: 240px;
                background-color: white;
                border-radius: 8px;
                position: relative;
                margin: 8px;
                box-shadow: #eee 2px 2px 10px;



                .titledesc{
                    position: absolute;
                    top: 45px;
                    right: 0;
                    font-size: 30px;
                    font-weight: 600;
                    width: 220px;
                    letter-spacing: .91px;
                    line-height: 42px;
                    text-align: center;
                    color: #012257;
                    text-align: center;


                    .deslk{
                        font-size:14px!important;
                        line-height:16px!important;
                        margin-top:10px!important;
                        font-weight: 600;
                    }


                   
                    
                }

                .klng{
                    padding: 0 20px;
                    
                }

                .picBox{
                    width: 160px;
                    height: 160px;

                    img{
                        width: 100%;
                    }
                }

            }
        }


        
    }

    .bkugk{
                width: 200px;
                height: 200px;
                text-align: center;
                margin: 0 10px;

                img{
                    width: 100%;
                }
            }

    .threeWrapper{
        width: 100%;
        height: 200px;
        position: relative;
        background-color: #1a1e2a;

        .footerHeader{
            width: 1200px;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;


            


            .tubiao{
                font-size: 30px!important;
            }

            .bordl{
                border-bottom: none !important;
                padding: 0 !important;
            }


            .tilng{
                display: flex;
                justify-content: space-around;
                font-size: 20px;
                padding: 10px 0;
                color: #fff;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                margin-bottom: 20px;

                .okngfdf{
                    display: flex;
                    align-items: center;
                }

                .ilkg{
                    display: flex;
                   
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    line-height: 28px;
                    color: #fff
                }

                .olkgnjkg{
                    display: flex;
                    width: 250px !important;
                    
                }
            }
            
        }
    }
}

}


</style>